import { timeNewDate } from './timeNewDate'

/**
 * @description 当前时间是否在某个时间范围内
 * @param {*} timeOne
 * @param {*} timeTwo
 * @returns {Number|Null}
 */
export const timeScope = (timeOne: any, timeTwo: any): boolean => {
  const oneNewDate = timeNewDate(timeOne)
  const twoNewDate = timeNewDate(timeTwo)
  const currentDate = timeNewDate()
  return oneNewDate <= currentDate && currentDate <= twoNewDate
}
